module.exports = __webpack_public_path__ + "img/03logo-gkc2022.c6bef797.png";